import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "src/environments/environment";

// Normalize base URL (strip trailing slashes) to avoid double slashes in paths like /clusters//
const BACKEND_URL = (environment.apiUrl || "").replace(/\/+$/, "") + "/clusters";

@Injectable({
  providedIn: "root"
})

export class ClustersService {

  constructor(private http: HttpClient) { }

  getClusters(): Observable<any[]> {
    return this.http
      .get<{ message: string; clusters: any[] }>(BACKEND_URL + '/')
      .pipe(
        map(clusterData => {
          return [...clusterData.clusters];
        })
      );
  }

  /**
   * Same endpoint as getClusters(), but also returns `avalblesystems` if backend includes it.
   * Backwards compatible: if backend doesn't send it, the field is `undefined`.
   */
  getClustersWithAvailableSystems(): Observable<{ clusters: any[]; avalblesystems?: { '3DPrint'?: boolean; phPrint?: boolean } }> {
    return this.http
      .get<any>(BACKEND_URL + '/')
      .pipe(
        map((res) => {
          const clusters = Array.isArray(res) ? res : (res?.clusters || []);
          const avalblesystems = Array.isArray(res) ? undefined : res?.avalblesystems;
          return { clusters: [...clusters], avalblesystems };
        })
      );
  }

  clustersformaniger(): Observable<any[]> {
    return this.http
      .get<{ message: string; clusters: any[] }>(BACKEND_URL + '/clustersformaniger')
      .pipe(
        map(clusterData => {
          return [...clusterData.clusters];
        })
      );
  }

  getBranchesByClusterName(cluster: string): Observable<any[]> {
    return this.http
      .get<{ message: string; cluster: any }>(BACKEND_URL + '/byclustername/' + cluster)
      .pipe(
        map(cluster => {
          return cluster.cluster;
        })
      );
  }

  getClustersForEditInstructions(): Observable<any[]> {
    return this.http
      .get<{ message: string; clusters: any[] }>(BACKEND_URL + '/foredit')
      .pipe(
        map(clusterData => {
          return [...clusterData.clusters];
        })
      );
  }
  // =======================================
}


